import { css } from 'linaria';
import { theme } from '../../Theme';

// Use linaria css to style the component.
// All styling should be placed in :global().
// Begin all styling with root class name of component.

css`
  :global() {
    .cta {
      height: ${theme.button.desktop.height};
      width: fit-content;
      padding: ${theme.button.desktop.padding};
      cursor: pointer;
      background: black;

      border-radius: ${theme.button.desktop.borderRadius};

      ${theme.below.lg} {
        border-radius: ${theme.button.mobile.borderRadius};
      }

      a,
      div {
        color: white;
      }

      .link-evaluator {
        display: flex;
        justify-content: center;
        align-items: center;

        letter-spacing: 0.1em;
        font-size: 12px;
        font-weight: ${theme.fontWeights.semiBold};
        line-height: 100%;
        text-transform: uppercase;
      }

      &.accent {
        background: ${theme.colors.accent};
        a,
        div {
          color: ${theme.colors.white};
        }
        :hover,
        :active {
          background: ${theme.colors.variant.accent};
          > div {
            color: ${theme.colors.variant.white};
          }
          border: 1px solid ${theme.colors.variant.white};
        }
      }

      &.dark {
        background: ${theme.colors.black};
        a,
        div {
          color: ${theme.colors.white};
        }
        :hover,
        :active {
          background: ${theme.colors.variant.black};
        }
      }

      &.light {
        background: ${theme.colors.white};
        a,
        div {
          color: ${theme.colors.black};
        }
        :hover,
        :active {
          background: ${theme.colors.white};
        }
      }

      &.accent_outline {
        background: transparent;
        border: 1px solid ${theme.colors.accent};
        a,
        div {
          color: ${theme.colors.accent};
        }
        :hover,
        :active {
          background: ${theme.colors.accent};
          a,
          div {
            color: ${theme.colors.white};
          }
        }
      }

      &.light_outline {
        background: transparent;
        border: 1px solid ${theme.colors.white};
        a,
        div {
          color: ${theme.colors.white};
        }
        :hover,
        :active {
          background: ${theme.colors.white};
          a,
          div {
            color: ${theme.colors.black};
          }
        }
      }

      &.dark_outline {
        background: transparent;
        border: 1px solid ${theme.colors.black};
        a,
        div {
          color: ${theme.colors.black};
        }
        :hover,
        :active {
          background: ${theme.colors.black};
          a,
          div {
            color: ${theme.colors.white};
          }
        }
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
`;
